"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[99596],{

/***/ 4377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69428);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var assets_base64icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54392);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-left: 30px;\n  border-left: 0;\n  border-right: 0;\n  border-color: ",
        " !important;\n  box-shadow: unset !important;\n\n  input {\n    text-align: center;\n  }\n\n  .ant-input-number-handler-wrap {\n    opacity: 1;\n    display: flex;\n    border: unset;\n    width: 100%;\n    background: unset;\n    justify-content: space-between;\n  }\n\n  .ant-input-number-handler-up {\n    position: absolute;\n    line-height: 30px;\n    height: 32px;\n    width: 30px;\n    right: -29px;\n    top: -1px;\n    border: 1px solid ",
        ";\n    border-left: 0;\n    border-radius: 0 2px 2px 0;\n\n    span {\n      display: none !important;\n    }\n    ::before {\n      content: url(",
        ");\n    }\n  }\n\n  .ant-input-number-handler-down {\n    position: absolute;\n    line-height: 30px;\n    height: 32px;\n    width: 30px;\n    left: -29px;\n    top: -1px;\n    border: 1px solid ",
        ";\n    border-right: 0;\n    border-radius: 2px 0 0 2px;\n\n    span {\n      display: none !important;\n      border: unset;\n    }\n\n    ::before {\n      content: url(",
        ");\n    }\n  }\n\n  .ant-input-number-handler-up:hover,\n  .ant-input-number-handler-down:hover {\n    height: 32px !important;\n  }\n\n  .ant-input-number-handler,\n  .ant-input-number-handler-wrap:hover .ant-input-number-handler {\n    background: ",
        ";\n    height: 32px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs({
    formatter: function(value) {
        return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    parser: function(value) {
        return value.replace(/\s?|(,*)/g, "");
    }
}).withConfig({
    componentId: "sc-d36ac3ab-0"
})(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, assets_base64icon__WEBPACK_IMPORTED_MODULE_4__/* .plusIcon */ .R7, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, assets_base64icon__WEBPACK_IMPORTED_MODULE_4__/* .minusIcon */ .$s, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].aliceBlue */ .Z.aliceBlue));


/***/ }),

/***/ 22613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48761);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: calc(100% - 14px);\n\n  .ant-slider-rail {\n    display: none;\n  }\n\n  .ant-slider-handle {\n    border: solid 2px ",
        ";\n  }\n\n  :hover .ant-slider-handle,\n  .ant-slider-handle:hover {\n    border-color: ",
        " !important;\n  }\n\n  .ant-slider-track {\n    height: 1px;\n    background-color: ",
        ";\n  }\n\n  :hover .ant-slider-track {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-b8d003df-0"
})(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].veryLightGrey */ .Z.veryLightGrey, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary));


/***/ }),

/***/ 19382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_AutoOrder; }
});

// UNUSED EXPORTS: AutoOrder

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Modal.js
var Modal = __webpack_require__(16368);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/lib/analytics/autoOrder.ts
var autoOrder = __webpack_require__(66959);
// EXTERNAL MODULE: ./src/global/TradingModal/store.ts
var store = __webpack_require__(70362);
// EXTERNAL MODULE: ./src/global/Securities/utils/maintenance.ts + 2 modules
var maintenance = __webpack_require__(38525);
// EXTERNAL MODULE: ./src/global/Securities/constants/transactionForm.ts
var transactionForm = __webpack_require__(9657);
// EXTERNAL MODULE: ./src/global/Securities/types/transaction.ts
var transaction = __webpack_require__(2078);
// EXTERNAL MODULE: ./src/global/Securities/stores/usePortfolioDetailStore.ts + 1 modules
var usePortfolioDetailStore = __webpack_require__(98976);
// EXTERNAL MODULE: ./node_modules/zustand/esm/shallow.js
var shallow = __webpack_require__(60374);
// EXTERNAL MODULE: ./src/features/transaction/useTradingStore.ts
var useTradingStore = __webpack_require__(93918);
// EXTERNAL MODULE: ./src/global/Securities/stores/useOrderDetailStore.ts
var useOrderDetailStore = __webpack_require__(87127);
// EXTERNAL MODULE: ./src/lib/stores/tradingOperation.ts + 1 modules
var tradingOperation = __webpack_require__(31532);
// EXTERNAL MODULE: ./src/hooks/useTradingAccount.ts
var useTradingAccount = __webpack_require__(64999);
// EXTERNAL MODULE: ./src/features/trade/components/styled.ts
var styled = __webpack_require__(94514);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./src/hooks/useToggle.ts
var useToggle = __webpack_require__(64700);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/global/TradingModal/constant.ts
var constant = __webpack_require__(29097);
// EXTERNAL MODULE: ./src/utils/number.js
var number = __webpack_require__(62974);
// EXTERNAL MODULE: ./src/lib/stores/tradingData.ts + 1 modules
var tradingData = __webpack_require__(36902);
// EXTERNAL MODULE: ./src/global/AlertMessage/index.tsx
var AlertMessage = __webpack_require__(6430);
// EXTERNAL MODULE: ./src/global/Securities/components/InputStepper/index.tsx + 1 modules
var InputStepper = __webpack_require__(97077);
// EXTERNAL MODULE: ./src/global/Securities/utils/transactionPrice.ts
var transactionPrice = __webpack_require__(98306);
// EXTERNAL MODULE: ./src/utils/axiosUtils.ts
var axiosUtils = __webpack_require__(75738);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./src/lib/api/smartOrder.ts
var smartOrder = __webpack_require__(59140);
// EXTERNAL MODULE: ./src/global/AlertErrorMessage/index.js + 1 modules
var AlertErrorMessage = __webpack_require__(25516);
// EXTERNAL MODULE: ./src/constants/successMessage.js
var successMessage = __webpack_require__(41208);
;// CONCATENATED MODULE: ./src/features/trade/components/AutoOrder/store.ts








var showErrorMessage = function(err) {
    if (!axiosUtils/* default.isAxiosError */.Z.isAxiosError(err)) {
        (0,AlertMessage/* default */.Z)({
            content: err.message,
            alertType: "plain-default",
            messageType: "error",
            hasCloseIcon: false
        });
    }
};
var autoOrderStore = (0,esm/* default */.ZP)(function(set) {
    return {
        stockData: [],
        isLoading: false,
        resetStockData: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        set({
                            stockData: []
                        });
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })),
        getStockData: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
                var response, data;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoading: true
                            });
                            _ctx.next = 4;
                            return (0,smartOrder/* getStockData */.Xz)(payload);
                        case 4:
                            response = _ctx.sent;
                            if (response === null || response === void 0 ? void 0 : response.data) {
                                _ctx.next = 7;
                                break;
                            }
                            throw new Error("Error while fetching data");
                        case 7:
                            data = response.data.data;
                            set({
                                stockData: data
                            });
                            _ctx.next = 14;
                            break;
                        case 11:
                            _ctx.prev = 11;
                            _ctx.t0 = _ctx["catch"](0);
                            if (!axiosUtils/* default.isAxiosError */.Z.isAxiosError(_ctx.t0)) {
                                showErrorMessage(_ctx.t0);
                            }
                        case 14:
                            _ctx.prev = 14;
                            set({
                                isLoading: false
                            });
                            return _ctx.finish(14);
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        11,
                        14,
                        17
                    ]
                ]);
            }));
            return function(payload) {
                return _ref.apply(this, arguments);
            };
        }(),
        addSmartOrder: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload, type) {
                var response;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoading: true
                            });
                            _ctx.next = 4;
                            return (0,smartOrder/* postSmartOrder */.sU)(payload);
                        case 4:
                            response = _ctx.sent;
                            if (response === null || response === void 0 ? void 0 : response.data) {
                                _ctx.next = 7;
                                break;
                            }
                            throw new Error("Error while fetching data");
                        case 7:
                            (0,AlertErrorMessage/* default */.Z)("".concat(type, " berhasil dipasang"), successMessage/* default.ALERT_GREEN */.Z.ALERT_GREEN);
                            _ctx.next = 13;
                            break;
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](0);
                            if (!axiosUtils/* default.isAxiosError */.Z.isAxiosError(_ctx.t0)) {
                                showErrorMessage(_ctx.t0);
                            }
                        case 13:
                            _ctx.prev = 13;
                            set({
                                isLoading: false
                            });
                            return _ctx.finish(13);
                        case 16:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        10,
                        13,
                        16
                    ]
                ]);
            }));
            return function(payload, type) {
                return _ref.apply(this, arguments);
            };
        }(),
        deleteSmartOrder: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload, type) {
                var response;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoading: true
                            });
                            _ctx.next = 4;
                            return (0,smartOrder/* smartOrderDelete */.zW)(payload);
                        case 4:
                            response = _ctx.sent;
                            if (response === null || response === void 0 ? void 0 : response.data) {
                                _ctx.next = 7;
                                break;
                            }
                            throw new Error("Error while fetching data");
                        case 7:
                            (0,AlertErrorMessage/* default */.Z)("".concat(type, " berhasil dihapus"), successMessage/* default.ALERT_GREEN */.Z.ALERT_GREEN);
                            _ctx.next = 13;
                            break;
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](0);
                            showErrorMessage(_ctx.t0);
                        case 13:
                            _ctx.prev = 13;
                            set({
                                isLoading: false
                            });
                            return _ctx.finish(13);
                        case 16:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        10,
                        13,
                        16
                    ]
                ]);
            }));
            return function(payload, type) {
                return _ref.apply(this, arguments);
            };
        }(),
        editSmartOrder: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload, type) {
                var response;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoading: true
                            });
                            _ctx.next = 4;
                            return (0,smartOrder/* editSmartOrder */.GP)(payload);
                        case 4:
                            response = _ctx.sent;
                            if (response === null || response === void 0 ? void 0 : response.data) {
                                _ctx.next = 7;
                                break;
                            }
                            throw new Error("Error while fetching data");
                        case 7:
                            (0,AlertErrorMessage/* default */.Z)("".concat(type, " berhasil diubah"), successMessage/* default.ALERT_GREEN */.Z.ALERT_GREEN);
                            _ctx.next = 13;
                            break;
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](0);
                            if (!axiosUtils/* default.isAxiosError */.Z.isAxiosError(_ctx.t0)) {
                                showErrorMessage(_ctx.t0);
                            }
                        case 13:
                            _ctx.prev = 13;
                            set({
                                isLoading: false
                            });
                            return _ctx.finish(13);
                        case 16:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        10,
                        13,
                        16
                    ]
                ]);
            }));
            return function(payload, type) {
                return _ref.apply(this, arguments);
            };
        }()
    };
});
/* harmony default export */ var AutoOrder_store = (autoOrderStore);

// EXTERNAL MODULE: ./src/features/trade/components/AutoOrder/util.ts
var util = __webpack_require__(65470);
;// CONCATENATED MODULE: ./src/features/trade/components/AutoOrder/FormModal.tsx
/* eslint-disable no-param-reassign */ 



























var FormModal = function(param) {
    var type = param.type, visible = param.visible, onCancel = param.onCancel, portfolio = param.portfolio, onDelete = param.onDelete, afterSubmit = param.afterSubmit;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(), 2), isVisible = ref[0], toggle = ref[1];
    var available_lot = portfolio.available_lot, price_average_fee = portfolio.price_average_fee;
    var autoOrderId = (0,useTradingStore/* default */.Z)(function(s) {
        return s.autoOrderId;
    });
    var autoOrderStatus = (0,useTradingStore/* default */.Z)(function(s) {
        return s.autoOrderStatus;
    });
    var priceOrder = (0,useTradingStore/* default */.Z)(function(s) {
        return s.priceOrder;
    });
    var orderOpen = (0,useTradingStore/* default */.Z)(function(s) {
        return s.orderOpen;
    });
    var ref1 = AutoOrder_store(), stockData = ref1.stockData, addSmartOrder = ref1.addSmartOrder, editSmartOrder = ref1.editSmartOrder, isLoading = ref1.isLoading;
    var configFormula = (0,tradingData/* default */.Z)(function(s) {
        return s.configFormula.data;
    });
    var postTradeAmend = (0,tradingOperation/* default */.Z)().postTradeAmend;
    var ref2 = (0,react.useState)(0), lot = ref2[0], setLot = ref2[1];
    var ref3 = (0,react.useState)(0), price = ref3[0], setPrice = ref3[1];
    var autoOrderData = (0,react.useMemo)(function() {
        return stockData.find(function(item) {
            return item.id === autoOrderId;
        });
    }, [
        stockData
    ]);
    var isAmendAutoOrderOpen = !!autoOrderId && autoOrderStatus === "OPEN";
    var availableLot = (0,react.useMemo)(function() {
        var roundedAvailableLot = Math.floor(available_lot);
        if (isAmendAutoOrderOpen && typeof roundedAvailableLot === "number" && !Number.isNaN(roundedAvailableLot)) {
            return roundedAvailableLot + Number(orderOpen);
        }
        return available_lot;
    }, [
        autoOrderData,
        available_lot,
        orderOpen,
        isAmendAutoOrderOpen
    ]);
    (0,react.useEffect)(function() {
        if (autoOrderData && !isLoading) {
            setLot(Number(autoOrderData.shares) / constant/* lotSize */.CQ);
            setPrice(autoOrderData.price);
        }
    }, [
        autoOrderData,
        isLoading
    ]);
    (0,react.useEffect)(function() {
        // Amend auto order with open status
        if (isAmendAutoOrderOpen) {
            setLot(Number(orderOpen));
            setPrice(Number(priceOrder));
        }
    }, [
        autoOrderId,
        autoOrderStatus,
        orderOpen,
        priceOrder
    ]);
    (0,react.useEffect)(function() {
        if (visible) {
            if (autoOrderId) {
                (0,autoOrder/* trackAutoSellAlterOrderView */.GK)("Edit");
            } else {
                (0,autoOrder/* trackAutoSellFormView */.i7)(transactionForm/* smartOrderText */.nz[type]);
            }
        }
    }, [
        visible
    ]);
    (0,react.useEffect)(function() {
        if (isVisible) {
            (0,autoOrder/* trackAutoSellInfoView */.vD)(transactionForm/* smartOrderText */.nz[type]);
        }
    }, [
        isVisible
    ]);
    var _obj;
    var data = (_obj = {}, (0,_define_property/* default */.Z)(_obj, transaction/* SmartOrderCode.StopLoss */.H1.StopLoss, {
        image: "/images/stop-loss.svg",
        text: "adalah tindakan untuk menjual saham secara otomatis di harga tertentu untuk membatasi kerugian."
    }), (0,_define_property/* default */.Z)(_obj, transaction/* SmartOrderCode.TakeProfit */.H1.TakeProfit, {
        image: "/images/take-profit.svg",
        text: "adalah tindakan untuk mengambil profit kamu secara otomatis setelah harga saham mencapai target yang kamu inginkan."
    }), _obj);
    var handleLotChange = function(value) {
        var roundedAvailableLot = Math.floor(availableLot);
        if (Number.isNaN(value)) {
            setLot(roundedAvailableLot);
            return;
        }
        if (value > roundedAvailableLot) {
            setLot(roundedAvailableLot);
            (0,AlertMessage/* default */.Z)({
                alertType: "snackbar",
                messageType: "error",
                content: "Jumlah Lot tidak bisa melebihi Available Lot",
                hasCloseIcon: true
            });
            return;
        }
        setLot(value);
    };
    var getStepValidation = function(value) {
        var up = (0,transactionPrice/* getFraction */.n)(value).up;
        if (value % up !== 0) {
            (0,AlertMessage/* default */.Z)({
                alertType: "snackbar",
                messageType: "error",
                content: "Harga disesuaikan berdasarkan fraksi",
                hasCloseIcon: true
            });
            return value - value % up;
        }
        return value;
    };
    var handlePriceChangeValidation = (0,react.useCallback)(lodash_debounce_default()(function(value) {
        var valueWithStep = getStepValidation(value);
        if (valueWithStep !== value) {
            setPrice(valueWithStep);
        }
    }, 300), []);
    var handlePriceChange = function(value) {
        setPrice(value);
        if (value > 0) handlePriceChangeValidation(value);
        (0,autoOrder/* trackAutoSellOrderQuantityAdjusted */.bG)();
    };
    var handlePriceBlur = function() {
        var newPrice = getStepValidation(price);
        if (price !== newPrice) {
            setPrice(newPrice);
            (0,autoOrder/* trackAutoSellOrderQuantityAdjusted */.bG)();
        }
    };
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var dataOrder, ref, ref1, SELL_GAIN;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!autoOrderId) {
                            _ctx.next = 13;
                            break;
                        }
                        if (!(autoOrderStatus === "OPEN")) {
                            _ctx.next = 7;
                            break;
                        }
                        dataOrder = {
                            price: price,
                            shares: lot * constant/* lotSize */.CQ,
                            order_id: autoOrderId
                        };
                        _ctx.next = 5;
                        return postTradeAmend([
                            dataOrder
                        ]);
                    case 5:
                        _ctx.next = 10;
                        break;
                    case 7:
                        ;
                        _ctx.next = 10;
                        return editSmartOrder({
                            id: autoOrderId,
                            shares: (ref = lot * constant/* lotSize */.CQ) === null || ref === void 0 ? void 0 : ref.toString(),
                            price: price
                        }, transactionForm/* smartOrderText */.nz[type]);
                    case 10:
                        afterSubmit();
                        _ctx.next = 17;
                        break;
                    case 13:
                        ;
                        _ctx.next = 16;
                        return addSmartOrder({
                            stock_code: portfolio.symbol,
                            shares: (ref1 = lot * constant/* lotSize */.CQ) === null || ref1 === void 0 ? void 0 : ref1.toString(),
                            price: price,
                            type: type
                        }, transactionForm/* smartOrderText */.nz[type]);
                    case 16:
                        afterSubmit();
                    case 17:
                        SELL_GAIN = (0,util/* generateTradingVariableGeneral */.g)(configFormula, lot, price, price_average_fee, portfolio.symbol).SELL_GAIN;
                        (0,autoOrder/* trackAutoSellOrderConfirmed */.RI)(transactionForm/* smartOrderText */.nz[type], portfolio.symbol, lot, price, "".concat((0,number/* formatNumber */.uf)(SELL_GAIN, true, "0.0"), "%"));
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
                visible: visible && !isVisible,
                onCancel: function() {
                    onCancel();
                    (0,autoOrder/* trackAutoSellOrderCanceled */.K)();
                },
                centered: true,
                width: 520,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        width: "100%",
                        p: "16px",
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: autoOrderId,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    as: "button",
                                    className: "button-unstyled",
                                    color: color/* default.sunsetOrange */.Z.sunsetOrange,
                                    size: "18px",
                                    family: "bold",
                                    ml: "4px",
                                    onClick: function() {
                                        return onDelete(autoOrderData);
                                    },
                                    children: "Delete"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                align: "center",
                                justify: "center",
                                width: "100%",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        align: "center",
                                        family: "bold",
                                        size: "18px",
                                        // @ts-expect-error
                                        mr: "5px",
                                        ml: autoOrderId ? "-55px" : "0",
                                        children: transactionForm/* smartOrderText */.nz[type]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "button-unstyled",
                                        onClick: function() {
                                            toggle();
                                            (0,autoOrder/* trackAutoSellInfoSelected */.V0)(transactionForm/* smartOrderText */.nz[type]);
                                        },
                                        type: "button",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                            src: "/icon/info.svg",
                                            width: "12px"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        align: "center",
                        justify: "space-between",
                        p: "8px 20px",
                        width: "100%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                size: "16px",
                                children: "Lot"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputStepper/* default */.Z, {
                                containerStyle: {
                                    width: 160
                                },
                                min: 0,
                                max: availableLot,
                                value: lot,
                                onChange: handleLotChange,
                                disabled: isLoading
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        align: "center",
                        justify: "space-between",
                        p: "8px 20px 20px 20px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                size: "16px",
                                children: "Price"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputStepper/* default */.Z, {
                                containerStyle: {
                                    width: 160
                                },
                                value: price,
                                min: 0,
                                max: Number.MAX_SAFE_INTEGER,
                                step: (0,transactionPrice/* getStepFractionByValue */.Z)(price),
                                onChange: handlePriceChange,
                                onBlur: handlePriceBlur,
                                disabled: isLoading,
                                disableDecimal: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ModalButtonContainer */.qD, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ModalTradingButton */.pl, {
                            className: lot === 0 || price === 0 ? "disabled" : "exercise",
                            disabled: lot === 0 || price === 0,
                            onClick: lot === 0 || price === 0 ? null : onSubmit,
                            loading: isLoading,
                            children: "Submit"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
                visible: isVisible,
                onCancel: function() {
                    toggle();
                    (0,autoOrder/* trackAutoSellOrderInfoClosed */.fh)();
                },
                centered: true,
                width: 520,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        align: "center",
                        family: "bold",
                        size: "18px",
                        p: "16px",
                        pb: "0",
                        children: transactionForm/* smartOrderText */.nz[type]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            padding: 16
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                align: "center",
                                justify: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: data[type].image
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                as: "p",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        family: "bold",
                                        as: "span",
                                        children: transactionForm/* smartOrderText */.nz[type]
                                    }),
                                    " ",
                                    data[type].text
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var AutoOrder_FormModal = (FormModal);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@deprecated-ui/trading/InputNumber.js
var InputNumber = __webpack_require__(4377);
// EXTERNAL MODULE: ./node_modules/antd/es/skeleton/index.js + 8 modules
var skeleton = __webpack_require__(41080);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/features/trade/components/AutoOrder/styled.ts
/* eslint-disable indent */ /* eslint-disable no-confusing-arrow */ 
function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  & .ant-skeleton-title {\n    margin: 0;\n  }\n\n  & .ant-skeleton-content .ant-skeleton-title + .ant-skeleton-paragraph {\n    margin: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & .ant-skeleton-title {\n    margin: 0;\n  }\n\n  & .ant-skeleton-paragraph {\n    margin-bottom: 0;\n  }\n\n  & .ant-skeleton-content .ant-skeleton-paragraph > li + li {\n    margin-top: 12px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & .ant-modal-content {\n    border-radius: 3px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 40px 20px 20px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & > div {\n    border-bottom: 1px solid ",
        ";\n\n    &:last-child {\n      border: 0;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px 20px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  &:not(:last-child) {\n    border-bottom: 1px solid ",
        ";\n  }\n\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 30px;\n  width: ",
        ";\n\n  .ant-input-number-input {\n    padding: 0px !important;\n  }\n\n  .ant-input-number-handler-wrap {\n    width: 0px !important;\n  }\n\n  .ant-input-number-handler-up {\n    border-left: 1px solid ",
        ";\n    left: ",
        ";\n  }\n\n  .ant-input-number-handler-down {\n    border-right: 1px solid ",
        ";\n    left: ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}







var TitleSkeleton = (0,styled_components_browser_esm/* default */.ZP)(skeleton/* default */.Z).attrs({
    paragraph: {
        rows: 0
    }
}).withConfig({
    componentId: "sc-1376f9ef-0"
})(_templateObject());
var ContentSkeleton = (0,styled_components_browser_esm/* default */.ZP)(skeleton/* default */.Z).withConfig({
    componentId: "sc-1376f9ef-1"
})(_templateObject1());
var AutoOrderModal = (0,styled_components_browser_esm/* default */.ZP)(Modal/* default */.Z).withConfig({
    componentId: "sc-1376f9ef-2"
})(_templateObject2());
var ListWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1376f9ef-3"
})(_templateObject3());
var AutoOrderFieldWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1376f9ef-4"
})(_templateObject4(), color/* default.downgray */.Z.downgray);
var AutoOrderFieldGroup = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1376f9ef-5"
})(_templateObject5());
var Option = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    as: "button",
    p: "20px",
    justify: "space-between",
    align: "center",
    className: "button-unstyled"
}).withConfig({
    componentId: "sc-1376f9ef-6"
})(_templateObject6(), color/* default.component */.Z.component, color/* default.aliceBlue */.Z.aliceBlue);
var styled_InputNumber = (0,styled_components_browser_esm/* default */.ZP)(InputNumber/* default */.Z).attrs({
    formatter: function(value) {
        return (0,number/* formatNumber */.uf)(value);
    },
    parser: function(value) {
        return value.replace(/[, ]+/g, "").trim();
    }
}).withConfig({
    componentId: "sc-1376f9ef-7"
})(_templateObject7(), function(props) {
    return(// @ts-expect-error
    props.isForTriggerPrice ? "63px !important" : "100px !important");
}, color/* default.gainsboro */.Z.gainsboro, function(props) {
    return(// @ts-expect-error
    props.isForTriggerPrice ? "-1px !important" : "0px !important");
}, color/* default.gainsboro */.Z.gainsboro, function(props) {
    return(// @ts-expect-error
    props.isForTriggerPrice ? "-91px !important" : "-130px !important");
});
var InfoMenuButton = styled_components_browser_esm/* default.button.attrs */.ZP.button.attrs({
    className: "button-unstyled"
}).withConfig({
    componentId: "sc-1376f9ef-8"
})(_templateObject8());

;// CONCATENATED MODULE: ./src/features/trade/components/AutoOrder/index.tsx


























var MODAL_TYPES = {
    menu: "menu",
    info: "info",
    form: "form",
    delete: "delete"
};
var options = [
    {
        type: transaction/* SellOrderType.StopLoss */.qK.StopLoss,
        text: transactionForm/* orderTypeOptions.Sell.StopLoss */.Ud.Sell.StopLoss
    },
    {
        type: transaction/* SellOrderType.TakeProfit */.qK.TakeProfit,
        text: transactionForm/* orderTypeOptions.Sell.TakeProfit */.Ud.Sell.TakeProfit
    }, 
];
var _obj;
var orderLabelMapper = (_obj = {}, (0,_define_property/* default */.Z)(_obj, transaction/* SmartOrderCode.StopLoss */.H1.StopLoss, transaction/* SmartOrderType.StopLoss */.om.StopLoss), (0,_define_property/* default */.Z)(_obj, transaction/* SmartOrderCode.TakeProfit */.H1.TakeProfit, transaction/* SmartOrderType.TakeProfit */.om.TakeProfit), _obj);
var AutoOrder = function(param) {
    var visible = param.visible, onCancel = param.onCancel, symbol = param.symbol, initialType = param.initialType;
    var isCheckInitialAmend = (0,react.useRef)(false);
    var resetOrderDetail = (0,useOrderDetailStore/* default */.Z)(function(s) {
        return s.resetOrderDetail;
    });
    var autoOrderId = (0,useTradingStore/* default */.Z)(function(s) {
        return s.autoOrderId;
    });
    var orderLabel = (0,useTradingStore/* default */.Z)(function(s) {
        return s.orderLabel;
    });
    var orderGtc = (0,useTradingStore/* default */.Z)(function(s) {
        return s.orderGtc;
    });
    var smartOrderId = (0,useTradingStore/* default */.Z)(function(s) {
        return s.smartOrderId;
    });
    var ref = (0,usePortfolioDetailStore/* default */.Z)(function(s) {
        return {
            portfolio: s.data,
            loadPortfolioDetail: s.loadPortfolioDetail
        };
    }, shallow/* default */.Z), portfolio = ref.portfolio, loadPortfolioDetail = ref.loadPortfolioDetail;
    var isRealTrading = (0,useTradingAccount/* default */.Z)().isRealTrading;
    var postTradeCancel = (0,tradingOperation/* default */.Z)(function(s) {
        return {
            postTradeCancel: s.postTradeCancel
        };
    }, shallow/* default */.Z).postTradeCancel;
    var have_smartorder = portfolio.have_smartorder;
    var initialModal = MODAL_TYPES.menu;
    var ref1 = (0,react.useState)(initialModal), openModal = ref1[0], setOpenModal = ref1[1];
    var ref2 = (0,react.useState)(initialType), currentType = ref2[0], setCurrentType = ref2[1];
    var ref3 = (0,react.useState)(""), prevModal = ref3[0], setPrevModal = ref3[1];
    var ref4 = AutoOrder_store(), stockData = ref4.stockData, deleteSmartOrder = ref4.deleteSmartOrder, getStockData = ref4.getStockData, resetStockData = ref4.resetStockData, isLoading = ref4.isLoading;
    var setAutoBuy = (0,store/* default */.Z)(function(s) {
        return s.setAutoBuy;
    });
    var autoOrderData = (0,react.useMemo)(function() {
        return stockData.find(function(item) {
            return item.id === autoOrderId;
        });
    }, [
        stockData,
        autoOrderId
    ]);
    (0,react.useEffect)(function() {
        resetStockData();
    }, []);
    (0,react.useEffect)(function() {
        if (have_smartorder) {
            getStockData({
                stock_code: symbol
            });
        }
    }, [
        symbol,
        have_smartorder
    ]);
    (0,react.useEffect)(function() {
        if (initialModal === MODAL_TYPES.menu) {
            (0,autoOrder/* trackAutoSellAutoOrderView */.ur)();
        }
    }, [
        initialModal
    ]);
    (0,react.useEffect)(function() {
        if (autoOrderData === null || autoOrderData === void 0 ? void 0 : autoOrderData.type_text) {
            var newType = options.find(function(opt) {
                return opt.text === autoOrderData.type_text;
            });
            if (newType) {
                setCurrentType(newType.type);
            }
        }
    }, [
        autoOrderData
    ]);
    var resetData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return resetStockData();
                    case 2:
                        isCheckInitialAmend.current = false;
                        resetOrderDetail();
                        setOpenModal(initialModal);
                        setPrevModal("info");
                        setAutoBuy(false);
                        onCancel();
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function resetData() {
            return _ref.apply(this, arguments);
        };
    }();
    var deleteAutoOrder = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!autoOrderData) {
                            _ctx.next = 4;
                            break;
                        }
                        _ctx.next = 3;
                        return deleteSmartOrder({
                            id: autoOrderData === null || autoOrderData === void 0 ? void 0 : autoOrderData.id
                        }, autoOrderData === null || autoOrderData === void 0 ? void 0 : autoOrderData.type_text);
                    case 3:
                        resetData();
                    case 4:
                        if (!(!autoOrderData && autoOrderId && !smartOrderId)) {
                            _ctx.next = 8;
                            break;
                        }
                        _ctx.next = 7;
                        return postTradeCancel({
                            orderkey: "W-WITHDRAW-".concat(Date.now()),
                            orderid: autoOrderId,
                            gtc: orderGtc,
                            symbol: symbol,
                            isRealTrading: isRealTrading
                        });
                    case 7:
                        resetData();
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function deleteAutoOrder() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleOptionClick = function(opt) {
        return function() {
            (0,maintenance/* withMaintenanceGuard */.L)(function() {
                (0,autoOrder/* trackAutoSellOrderTypeSelected */.Jl)(opt.text, symbol);
                setOpenModal(MODAL_TYPES.form);
                setPrevModal(MODAL_TYPES.menu);
                setCurrentType(opt.type);
            });
        };
    };
    (0,react.useEffect)(function() {
        loadPortfolioDetail(symbol);
    }, [
        symbol
    ]);
    (0,react.useEffect)(function() {
        if (autoOrderId && !isCheckInitialAmend.current) {
            setOpenModal(MODAL_TYPES.form);
        }
        isCheckInitialAmend.current = true;
    }, [
        autoOrderId
    ]);
    (0,react.useEffect)(function() {
        if (initialType) {
            setCurrentType(initialType);
            setOpenModal(MODAL_TYPES.form);
        } else {
            setCurrentType(transaction/* SellOrderType.StopLoss */.qK.StopLoss);
        }
    }, [
        initialType
    ]);
    (0,react.useEffect)(function() {
        // AMEND ONLY
        if (!autoOrderData && autoOrderId && !smartOrderId && orderLabel) {
            setCurrentType(orderLabelMapper[orderLabel]);
        }
    }, [
        autoOrderData,
        autoOrderId,
        orderLabel,
        smartOrderId
    ]);
    if (!visible) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: openModal === "menu",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
                    visible: visible,
                    onCancel: function() {
                        if (prevModal) setOpenModal(prevModal);
                        else {
                            onCancel();
                            (0,autoOrder/* trackAutoOrderCanceled */.iY)();
                        }
                    },
                    centered: true,
                    width: 520,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            align: "center",
                            family: "bold",
                            size: "18px",
                            p: "16px",
                            children: [
                                "Auto Order ",
                                symbol
                            ]
                        }),
                        options.map(function(opt) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Option, {
                                onClick: handleOptionClick(opt),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            size: "16px",
                                            color: color/* default.highempahis */.Z.highempahis,
                                            children: opt.text
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                                        className: "icon-trading_back reverse",
                                        color: color/* default.highempahis */.Z.highempahis
                                    })
                                ]
                            }, opt.type);
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: openModal === MODAL_TYPES.delete,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
                    visible: openModal === MODAL_TYPES.delete,
                    onCancel: function() {
                        if (prevModal) setOpenModal(prevModal);
                        else onCancel();
                        (0,autoOrder/* trackAutoSellOrderDeleted */.Pz)();
                    },
                    centered: true,
                    width: 520,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            direction: "column",
                            align: "center",
                            justify: "space-around",
                            // @ts-expect-error
                            p: "60px 40px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    align: "center",
                                    family: "bold",
                                    size: "18px",
                                    mb: "16px",
                                    children: [
                                        "Hapus ",
                                        transactionForm/* orderTypeOptions.Sell */.Ud.Sell[currentType]
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    color: color/* default.highgray */.Z.highgray,
                                    children: [
                                        "Kamu ingin menghapus ",
                                        transactionForm/* smartOrderText */.nz[currentType],
                                        " ini?"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ModalButtonContainer */.qD, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ModalTradingButton */.pl, {
                                    style: {
                                        backgroundColor: color/* default.light */.Z.light
                                    },
                                    onClick: function() {
                                        if (prevModal) {
                                            setOpenModal(prevModal);
                                        } else onCancel();
                                        (0,autoOrder/* trackAutoSellDeleteCanceled */.Vf)();
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: color/* default.primary */.Z.primary,
                                        family: "bold",
                                        size: "16px",
                                        children: "Cancel"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ModalTradingButton */.pl, {
                                    className: "sell",
                                    onClick: deleteAutoOrder,
                                    loading: isLoading,
                                    children: "Delete"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: openModal === MODAL_TYPES.form,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoOrder_FormModal, {
                    visible: openModal === "form",
                    onCancel: onCancel,
                    type: transaction/* SmartOrderCode */.H1[currentType],
                    portfolio: portfolio,
                    afterSubmit: resetData,
                    onDelete: function() {
                        setPrevModal(MODAL_TYPES.form);
                        setOpenModal(MODAL_TYPES.delete);
                        (0,autoOrder/* trackAutoSellAlterOrderSelected */.HJ)("Add");
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var components_AutoOrder = (AutoOrder);


/***/ }),

/***/ 65470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ generateTradingVariableGeneral; }
/* harmony export */ });
/* unused harmony export generateTradingVariableMain */
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83153);
/* eslint-disable no-unused-vars */ /* eslint-disable no-eval */ /* eslint-disable no-new-func */ 
var calculatePriceFraction = function(stockType, price) {
    var priceFraction = 1;
    if (stockType && stockType.toLowerCase() === constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .STOCK_TYPE.saham */ .L2.saham) {
        if (price > 200 && price <= 500) {
            priceFraction = 2;
        } else if (price > 500 && price <= 2000) {
            priceFraction = 5;
        } else if (price > 2000 && price <= 5000) {
            priceFraction = 10;
        } else if (price > 5000) {
            priceFraction = 25;
        }
    }
    return priceFraction;
};
var calculateFormula = function(args, formula) {
    return new Function(args, "return ".concat(formula))();
};
var generateTradingVariableMain = function(configFormula, lot, price, isStockCorporateActions) {
    var _formula = configFormula.formula, fee_buy = _formula.fee_buy, fee_sell = _formula.fee_sell, sell_amount_fee = _formula.sell_amount_fee, sell_amount_invested = _formula.sell_amount_invested, sell_amount_invested_fee = _formula.sell_amount_invested_fee, sell_amount_broker_fee = _formula.sell_amount_broker_fee, sell_amount_exchange_fee = _formula.sell_amount_exchange_fee, ca_sell_amount_fee = _formula.ca_sell_amount_fee, ca_sell_amount_invested = _formula.ca_sell_amount_invested, ca_sell_amount_invested_fee = _formula.ca_sell_amount_invested_fee, ca_sell_amount_broker_fee = _formula.ca_sell_amount_broker_fee, ca_sell_amount_exchange_fee = _formula.ca_sell_amount_exchange_fee, _preview_fee = configFormula.preview_fee, broker_fee = _preview_fee.broker_fee, exchange = _preview_fee.exchange;
    var LOT = Number(lot);
    var PRICE = Number(price);
    var FEE_BUY = Number(fee_buy);
    var FEE_SELL = Number(fee_sell);
    var BROKER_FEE = Number(broker_fee);
    var EXCHANGE_FEE_TOTAL_BUY = Number(exchange.exchange_fee_total_buy);
    var EXCHANGE_FEE_TOTAL_SELL = Number(exchange.exchange_fee_total_sell);
    var SELL_AMOUNT = eval(sell_amount_invested);
    var SELL_FEE = eval(sell_amount_fee);
    var SELL_AMOUNT_FEE = eval(sell_amount_invested_fee);
    var STOCKBIT_FEE = eval(sell_amount_broker_fee);
    var EXCHANGE_FEE = eval(sell_amount_exchange_fee);
    if (isStockCorporateActions) {
        SELL_AMOUNT = eval(ca_sell_amount_invested);
        SELL_FEE = eval(ca_sell_amount_fee);
        SELL_AMOUNT_FEE = eval(ca_sell_amount_invested_fee);
        STOCKBIT_FEE = eval(ca_sell_amount_broker_fee);
        EXCHANGE_FEE = eval(ca_sell_amount_exchange_fee);
    }
    return {
        SELL_AMOUNT: SELL_AMOUNT,
        SELL_FEE: SELL_FEE,
        SELL_AMOUNT_FEE: SELL_AMOUNT_FEE,
        STOCKBIT_FEE: STOCKBIT_FEE,
        EXCHANGE_FEE: EXCHANGE_FEE
    };
};
var generateTradingVariableGeneral = function(configFormula, lot, price, price_average_fee) {
    var type = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    var stockType = type;
    var isStockCorporateActions = constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .CORPORATE_ACTION_STOCK_TYPE.indexOf */ .Do.indexOf(stockType.toUpperCase()) > -1;
    var _formula = configFormula.formula, buy_amount_invested = _formula.buy_amount_invested, sell_profit_loss = _formula.sell_profit_loss, sell_gain = _formula.sell_gain;
    var LOT = Number(lot);
    var PRICE = Number(price);
    var ref = generateTradingVariableMain(configFormula, LOT, PRICE, isStockCorporateActions), SELL_AMOUNT = ref.SELL_AMOUNT, SELL_FEE = ref.SELL_FEE, SELL_AMOUNT_FEE = ref.SELL_AMOUNT_FEE, STOCKBIT_FEE = ref.STOCKBIT_FEE, EXCHANGE_FEE = ref.EXCHANGE_FEE;
    var BUY_AMOUNT_INVESTED_AVERAGE_PRICE_FEE = calculateFormula("LOT=".concat(LOT, ",PRICE=").concat(price_average_fee), buy_amount_invested);
    var SELL_PROFITLOSS = calculateFormula("SELL_AMOUNT_INVESTED_FEE=".concat(SELL_AMOUNT_FEE, ",BUY_AMOUNT_INVESTED_AVERAGE_PRICE_FEE=").concat(BUY_AMOUNT_INVESTED_AVERAGE_PRICE_FEE), sell_profit_loss);
    var SELL_GAIN = 100 * eval(sell_gain);
    var PRICE_FRACTION = calculatePriceFraction(stockType, PRICE);
    return {
        SELL_FEE: SELL_FEE,
        STOCKBIT_FEE: STOCKBIT_FEE,
        EXCHANGE_FEE: EXCHANGE_FEE,
        SELL_AMOUNT: SELL_AMOUNT,
        SELL_AMOUNT_FEE: SELL_AMOUNT_FEE,
        SELL_PROFITLOSS: SELL_PROFITLOSS,
        SELL_GAIN: SELL_GAIN,
        PRICE_FRACTION: PRICE_FRACTION
    };
};


/***/ }),

/***/ 93918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14671);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21455);



var useTradingStore = function(selector) {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
    if (context === undefined) {
        throw new Error("useTradingStore must be used within a TradingContext");
    }
    var store = context.tradingStore;
    if (!store) {
        throw new Error("useTradingStore is not defined in TradingContextProvider");
    }
    return (0,zustand__WEBPACK_IMPORTED_MODULE_2__/* .useStore */ .oR)(store, selector);
};
/* harmony default export */ __webpack_exports__["Z"] = (useTradingStore);


/***/ }),

/***/ 14467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12902);




var initialState = {
    activeModal: undefined,
    modalProps: {}
};
var useGlobalModalStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set, get) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialState), {
        setActiveModal: function(activeModal, props) {
            set({
                activeModal: activeModal
            });
            if (activeModal) {
                get().setModalProps(activeModal, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, props), {
                    onCancel: function() {
                        if (!(props === null || props === void 0 ? void 0 : props.preventClose)) get().setActiveModal();
                        if (props === null || props === void 0 ? void 0 : props.onCancel) props.onCancel();
                    }
                }));
            }
        },
        setModalProps: function(type, props) {
            set((0,immer__WEBPACK_IMPORTED_MODULE_3__/* .produce */ .Uy)(function(state) {
                state.modalProps[type] = props;
            }));
        },
        resetActiveModal: function() {
            return set({
                activeModal: undefined
            });
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (useGlobalModalStore);


/***/ }),

/***/ 68861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var ChevronDownSvg = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        fill: "none",
        viewBox: "0 0 16 16",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "1.5",
            d: "M4 6l4 4 4-4"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ChevronDownSvg);


/***/ }),

/***/ 42958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var InfoSvg = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        fill: "none",
        viewBox: "0 0 13 13",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "1.2",
            d: "M6.5 11.167a4.667 4.667 0 100-9.334 4.667 4.667 0 000 9.334zM6.5 8.367V6.5M6.5 4.633h.004"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InfoSvg);


/***/ }),

/***/ 97077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_InputStepper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/Securities/components/InputStepper/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  overflow: hidden;\n  border-radius: 2px;\n  border: 1px solid #dadada;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #f5f6f7;\n  width: 30px;\n  height: 32px;\n  border: none;\n  flex-shrink: 0;\n  transition: 0.3s opacity ease-out;\n  cursor: pointer;\n\n  &:disabled {\n    opacity: 0.75;\n    cursor: not-allowed;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n\n  width: 100%;\n  border: solid #dadada;\n  border-width: 0 1px;\n  text-align: center;\n\n  outline: none;\n\n  &::-webkit-outer-spin-button,\n  ::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  &[type='number'] {\n    -moz-appearance: textfield;\n  }\n\n  & .ant-input-number-handler-wrap {\n    display: none;\n  }\n\n  & .ant-input-number-input-wrap {\n    display: flex;\n    align-items: center;\n\n    & input {\n      text-align: center;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var InputStepContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5b57c1c-0"
})(_templateObject());
var StepButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-5b57c1c-1"
})(_templateObject1());
var StepInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-5b57c1c-2"
})(_templateObject2());

;// CONCATENATED MODULE: ./src/global/Securities/components/InputStepper/index.tsx
// TODO: Split InputStepper to InputNumber component







var InputStepper = function(_param) {
    var containerStyle = _param.containerStyle, _onChange = _param.onChange, onChange = _onChange === void 0 ? function() {} : _onChange, _step = _param.step, step = _step === void 0 ? 1 : _step, _disableDecimal = _param.disableDecimal, disableDecimal = _disableDecimal === void 0 ? false : _disableDecimal, _containerClassName = _param.containerClassName, containerClassName = _containerClassName === void 0 ? "" : _containerClassName, props = (0,_object_without_properties/* default */.Z)(_param, [
        "containerStyle",
        "onChange",
        "step",
        "disableDecimal",
        "containerClassName"
    ]);
    var ref, ref1;
    var ref2 = (0,react.useState)(((ref = props.value) === null || ref === void 0 ? void 0 : ref.toString()) || ((ref1 = props.defaultValue) === null || ref1 === void 0 ? void 0 : ref1.toString()) || "0"), inputValue = ref2[0], setInputValue = ref2[1];
    var ref3 = (0,react.useState)(false), active = ref3[0], setActive = ref3[1];
    var ref4 = (0,react.useMemo)(function() {
        var min = props.min, max = props.max;
        return {
            minValue: min === undefined ? -Infinity : Number(min),
            maxValue: max === undefined ? Infinity : Number(max)
        };
    }, [
        props.min,
        props.max
    ]), minValue = ref4.minValue, maxValue = ref4.maxValue;
    var formatter = function(value) {
        return Intl.NumberFormat("en-US").format(value);
    };
    var parser = function(value) {
        // Purposefully hardcoded number only to get separator symbol
        var thousandSeparator = Intl.NumberFormat("en-US").format(1111).replace(/[0-9]+/g, "");
        var decimalSeparator = Intl.NumberFormat("en-US").format(1.1).replace(/[0-9]+/g, "");
        var ref = (0,_sliced_to_array/* default */.Z)(value.replaceAll(thousandSeparator, "").split(decimalSeparator), 2), wholeValue = ref[0], tmp = ref[1], decimalValue = tmp === void 0 ? 0 : tmp;
        return Number("".concat(wholeValue).concat(decimalSeparator).concat(decimalValue));
    };
    var parsedInputValue = (0,react.useMemo)(function() {
        return parser(inputValue);
    }, [
        inputValue
    ]);
    var setTextCursor = function(target, position) {
        window.requestAnimationFrame(function() {
            target.focus();
            target.setSelectionRange(position, position);
        });
    };
    var getStep = function(key) {
        return step[key] || step;
    };
    // Clamp value optionally, set to Infinity to handle unclamped value
    var getClampedValue = function(value) {
        return Math.min(Math.max(value, minValue), maxValue);
    };
    var getProcessedValue = function(value) {
        var parsedValue = getClampedValue(parser(value));
        return {
            rawValue: parsedValue,
            formattedValue: formatter(parsedValue)
        };
    };
    var handleChange = function(e) {
        var value = e.target.value;
        var isReplaceZero = parsedInputValue === 0;
        var ref = getProcessedValue(isReplaceZero ? value.replace("0", "") : value), rawValue = ref.rawValue, formattedValue = ref.formattedValue;
        var selectionPos = e.target.selectionStart;
        // Handle on value not convertible to number
        if (Number.isNaN(rawValue)) return;
        // Handle when inputing decimal
        if (value[value.length - 1] === "." && !inputValue.includes(".") && !disableDecimal) {
            setInputValue("".concat(formattedValue, "."));
            return;
        }
        // Handle on removing comma
        if (formattedValue === inputValue) {
            // Check if the last character removed was '0'
            if (inputValue === "0" && selectionPos === 0) {
                // Set the cursor to the right of '0'
                setTextCursor(e.target, selectionPos + 1);
                return;
            }
            setTextCursor(e.target, selectionPos);
            return;
        }
        setInputValue(formattedValue);
        onChange(rawValue);
        // Prevent cursor jumping when adding and removing text
        var shiftPos = inputValue.length - value.length;
        var newCursor = selectionPos + (formattedValue.length - inputValue.length + shiftPos);
        setTextCursor(e.target, newCursor);
    };
    var handleStepDown = function() {
        var stepValue = getStep("down");
        var rawValue = getClampedValue(parsedInputValue - stepValue);
        setInputValue(formatter(rawValue));
        onChange(rawValue);
    };
    var handleStepUp = function() {
        var stepValue = getStep("up");
        var rawValue = getClampedValue(parsedInputValue + stepValue);
        setInputValue(formatter(rawValue));
        onChange(rawValue);
    };
    var handlePropValueChange = (0,react.useCallback)(function() {
        if (props.value === undefined) return;
        var newValue = formatter(getClampedValue(props.value || 0));
        setInputValue(newValue);
    }, [
        props.value
    ]);
    (0,react.useEffect)(function() {
        handlePropValueChange();
    }, [
        handlePropValueChange
    ]);
    var containerClass = "".concat(containerClassName, " ").concat(active ? "active" : "");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputStepContainer, {
        className: containerClass,
        style: containerStyle,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StepButton, {
                type: "button",
                "data-cy": "btn-step-down",
                onClick: handleStepDown,
                disabled: parsedInputValue <= minValue || props.disabled,
                children: "-"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StepInput, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                "data-cy": "input-step"
            }, props), {
                onChange: handleChange,
                value: inputValue,
                onBlur: function() {
                    return setActive(false);
                },
                onFocus: function() {
                    return setActive(true);
                }
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StepButton, {
                type: "button",
                "data-cy": "btn-step-up",
                onClick: handleStepUp,
                disabled: parsedInputValue >= maxValue || props.disabled,
                children: "+"
            })
        ]
    });
};
/* harmony default export */ var components_InputStepper = (InputStepper);


/***/ }),

/***/ 27607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var SkeletonWrapper = function(param) {
    var _loading = param.loading, loading = _loading === void 0 ? false : _loading, skeleton = param.skeleton, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: loading ? skeleton : children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SkeletonWrapper);


/***/ }),

/***/ 48453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ AutoOrderProduct; },
/* harmony export */   "j": function() { return /* binding */ AutoSellType; }
/* harmony export */ });
var AutoOrderProduct;
(function(AutoOrderProduct) {
    AutoOrderProduct["AutoBuy"] = "AB";
    AutoOrderProduct["AutoSell"] = "AS";
})(AutoOrderProduct || (AutoOrderProduct = {}));
var AutoSellType;
(function(AutoSellType) {
    AutoSellType["TakeProfit"] = "TP";
    AutoSellType["StopLoss"] = "SL";
})(AutoSellType || (AutoSellType = {}));


/***/ }),

/***/ 2941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ getFormattedCurrency; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99534);

var getFormattedCurrency = function(value) {
    var intlOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _currencyPrefix = intlOptions.currencyPrefix, currencyPrefix = _currencyPrefix === void 0 ? "Rp" : _currencyPrefix, options = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(intlOptions, [
        "currencyPrefix"
    ]);
    return "".concat(currencyPrefix).concat(value.toLocaleString(undefined, options));
};


/***/ }),

/***/ 98306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getStepFractionByValue; },
/* harmony export */   "n": function() { return /* binding */ getFraction; }
/* harmony export */ });
var fractionList = [
    {
        maxThreshold: 200,
        step: 1
    },
    {
        maxThreshold: 500,
        step: 2
    },
    {
        maxThreshold: 2000,
        step: 5
    },
    {
        maxThreshold: 5000,
        step: 10
    },
    // For handling largest value directly from loop
    {
        maxThreshold: Infinity,
        step: 25
    }, 
];
var getFraction = function(price) {
    var fraction = {
        up: null,
        down: null
    };
    // Loop fraction list to set up and down fraction step, if both exist loops break
    for(var i = 0; i < fractionList.length; i += 1){
        var _i = fractionList[i], maxThreshold = _i.maxThreshold, step = _i.step;
        if (!fraction.up && price < maxThreshold) fraction.up = step;
        if (!fraction.down && price <= maxThreshold) fraction.down = step;
        if (fraction.up && fraction.down) break;
    }
    return fraction;
};
var getStepFractionByValue = function(price) {
    var fraction = getFraction(price);
    // Loop fraction list to set up and down fraction step, if both exist loops break
    for(var i = 0; i < fractionList.length; i += 1){
        var _i = fractionList[i], maxThreshold = _i.maxThreshold, step = _i.step;
        if (!fraction.up && price < maxThreshold) fraction.up = step;
        if (!fraction.down && price <= maxThreshold) fraction.down = step;
        if (fraction.up && fraction.down) break;
    }
    // Calculate difference between fraction and price to round to fraction set
    var diffFractUp = price % fraction.up;
    var diffFractDown = price % fraction.down;
    return {
        up: diffFractUp === 0 ? fraction.up : fraction.up - diffFractUp,
        down: diffFractUp === 0 ? fraction.down : diffFractDown
    };
};


/***/ }),

/***/ 29735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useBondsAnalytics; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48028);



var EVENTS_NAMES = {
    bondsPageViewed: "FR Bonds Page Viewed",
    bondProductPageViewed: "FR Bonds Product Page Viewed",
    bondOrderPageViewed: "FR Bonds Order Page Viewed",
    bondPreviewOrderViewed: "FR Bonds Preview Order Viewed",
    bondOrderSuccessViewed: "FR Bonds Order Success Viewed",
    bondsAction: "FR Bonds Action"
};
var PAGE_NAMES = {
    "/stream": "Stream Page",
    "/symbol": "Product Page",
    "/securities": "Portofolio List",
    "/watchlist": "Watchlist Page",
    "/screener": "Screener Page",
    "/valuation": "Valuation Page",
    "/sector": "Sector Page",
    "/community": "Community Page"
};
function useBondsAnalytics() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    // fill the search related page
    var defaultPageSource = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var pageNames = Object.keys(PAGE_NAMES);
        var pageIndex = pageNames.find(function(path) {
            return router.pathname.startsWith(path) ? path : undefined;
        });
        if (pageIndex) {
            return PAGE_NAMES[pageIndex];
        }
        return "Search Page";
    }, [
        router.pathname
    ]);
    var FRBondsNavigateTrackers = {
        // When user landing on FR Bonds page
        onBondPageViewed: function onBondPageViewed(section) {
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondsPageViewed, {
                Section: section
            });
        },
        // When user landing on FR Bonds Product page
        onBondProductPageViewed: function onBondProductPageViewed(symbol, yieldValue) {
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondProductPageViewed, {
                Symbol: symbol,
                Yield: yieldValue
            });
        },
        // When user landing on FR Bonds Order page
        onBondOrderPageViewed: function onBondOrderPageViewed(orderType, symbol, sourcePage) {
            var yieldValue = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "-";
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondOrderPageViewed, {
                SourcePage: sourcePage || defaultPageSource,
                "Order Type": orderType,
                Symbol: symbol,
                Yield: yieldValue
            });
        },
        // When user landing on FR Bonds Preview Order page
        onBondPreviewOrderViewed: function onBondPreviewOrderViewed(orderType, symbol, sourcePage) {
            var yieldValue = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "-";
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondPreviewOrderViewed, {
                SourcePage: sourcePage || defaultPageSource,
                "Order Type": orderType,
                Symbol: symbol,
                Yield: yieldValue
            });
        },
        // When user landing on FR Bonds Order Success page
        onBondOrderSuccessViewed: function onBondOrderSuccessViewed(orderType, symbol, sourcePage) {
            var yieldValue = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "-";
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondOrderSuccessViewed, {
                SourcePage: sourcePage || defaultPageSource,
                "Order Type": orderType,
                Symbol: symbol,
                Yield: yieldValue
            });
        }
    };
    var FRBondActionTrackers = {
        // When user click FR Bonds introduction banner
        onIntroductionBannerClicked: function onIntroductionBannerClicked(sourcePage) {
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondsAction, {
                Action: "Introduction Banner Clicked",
                SourcePage: sourcePage || defaultPageSource
            });
        },
        // When user click “Saya Setuju” on FR Bonds TnC
        onTnCConfirmed: function onTnCConfirmed() {
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondsAction, {
                Action: "TnC Confirmed"
            });
        },
        // When user click FR Bonds Section/Catalog to be redirected to FR Bonds list
        onFRProductListClicked: function onFRProductListClicked(sourcePage) {
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondsAction, {
                Action: "FR Product List Clicked",
                SourcePage: sourcePage || defaultPageSource
            });
        },
        // When user click buy/sell button on FR product to initiate order
        onOrderButtonClicked: function onOrderButtonClicked(orderType, symbol, sourcePage) {
            var yieldValue = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "-";
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondsAction, {
                Action: "FR Order Button Clicked",
                SourcePage: sourcePage || defaultPageSource,
                "Order Type": orderType,
                Symbol: symbol,
                Yield: yieldValue
            });
        },
        // When user click buy/sell button on FR order page to finalize order
        onOrderPlaced: function onOrderPlaced(orderType, symbol, sourcePage) {
            var yieldValue = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "-";
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondsAction, {
                Action: "FR Order Placed",
                SourcePage: sourcePage || defaultPageSource,
                "Order Type": orderType,
                Symbol: symbol,
                Yield: yieldValue
            });
        },
        // When user click buy/sell button on FR order page, confirming the order
        onOrderConfirmed: function onOrderConfirmed(orderType, symbol, sourcePage) {
            var yieldValue = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "-";
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondsAction, {
                Action: "FR Order Confirmed",
                SourcePage: sourcePage || defaultPageSource,
                "Order Type": orderType,
                Symbol: symbol,
                Yield: yieldValue
            });
        }
    };
    return {
        FRBondsNavigateTrackers: FRBondsNavigateTrackers,
        FRBondActionTrackers: FRBondActionTrackers
    };
};


/***/ }),

/***/ 65205:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2497);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16368);
/* harmony import */ var global_TradingModal_store__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70362);
/* harmony import */ var global_TradingModal_RealTradingModal_TransactionModal_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55039);
/* harmony import */ var lib_entities_profile__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(333);
/* harmony import */ var lib_api_smartOrder__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(59140);
/* harmony import */ var global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2078);
/* harmony import */ var features_transaction_useTradingStore__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(93918);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(53616);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(61227);
















var title = "Dengan menggunakan fitur Auto Order, saya menyatakan dan memahami bahwa:";
var checkboxDescription = "Saya menyetujui Syarat & Ketentuan Penggunaan Auto Order di atas.";
var tnc = [
    "Saya mengerti risiko penggunaan fitur Auto Order.",
    "Fitur Auto Order hanya membantu proses otomatisasi dalam bertransaksi. Pemesanan melalui Auto Order adalah sepenuhnya tanggung jawab pengguna, PT. Stockbit Sekuritas Digital tidak bertanggung jawab atas segala kerugian yang mungkin bisa terjadi.",
    "Sistem akan mulai melakukan pengecekan harga pada pukul 09:00:00 WIB.",
    "Proses pembentukan harga pada saat sesi pembukaan dapat mempengaruhi order saya.",
    "Eksekusi Auto Order bergantung pada antrian di bursa dimana ada kemungkinan terjadinya jeda waktu.",
    "Pemesanan melalui Auto Order tidak menjamin akan sesuai dengan harga dan jumlah yang saya harapkan.",
    "Stockbit berhak melakukan penghentian sementara fasilitas automated trading jika terdapat resiko perdagangan yang mungkin timbul untuk menghindari kerugian yang tidak diinginkan", 
];
function AutoOrderTncModal(param) {
    var autoOrderType = param.autoOrderType, visible = param.visible, closeModal = param.closeModal, onAccept = param.onAccept;
    var setOrderType = (0,_store__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function(s) {
        return s.setOrderType;
    });
    var setOrderTypeGen = (0,features_transaction_useTradingStore__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(function(s) {
        return s.setOrderType;
    });
    var openFromWidget = (0,features_transaction_useTradingStore__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(function(s) {
        return s.openFromWidget;
    });
    var onSubmitAutoOrderTnC = (0,features_transaction_useTradingStore__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(function(s) {
        return s.onSubmitAutoOrderTnC;
    });
    var setAutoBuy = (0,global_TradingModal_store__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(state) {
        return state.setAutoBuy;
    });
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isTncAgree = ref[0], setTncAgree = ref[1];
    var ref1 = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(lib_entities_profile__WEBPACK_IMPORTED_MODULE_9__/* .selectors */ .wl), username = ref1.data.username;
    var saveLogTnc = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, logTnc, response;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        ;
                        logTnc = JSON.parse(localStorage.getItem("logTnc")) || [];
                        _ctx.next = 5;
                        return (0,lib_api_smartOrder__WEBPACK_IMPORTED_MODULE_10__/* .postSmartOrderTnC */ .xB)({
                            product: autoOrderType
                        });
                    case 5:
                        response = _ctx.sent;
                        if (!((response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.message) !== "success")) {
                            _ctx.next = 8;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 8:
                        if (!(0,global_TradingModal_RealTradingModal_TransactionModal_utils__WEBPACK_IMPORTED_MODULE_8__/* .checkIsAutoOrderTncAgreed */ .KK)(username, autoOrderType)) {
                            logTnc.push({
                                username: username,
                                product: autoOrderType
                            });
                            localStorage.setItem("logTnc", JSON.stringify(logTnc));
                        }
                        return _ctx.abrupt("return");
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function saveLogTnc() {
            return _ref.apply(this, arguments);
        };
    }();
    var onTncAgreed = function() {
        saveLogTnc();
        if (openFromWidget) {
            setOrderTypeGen(global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_11__/* .BuyOrderType.AutoBuy */ .dY.AutoBuy);
        } else setOrderType(global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_11__/* .BuyOrderType.AutoBuy */ .dY.AutoBuy);
        setAutoBuy(true);
        if (onSubmitAutoOrderTnC) {
            setTimeout(onSubmitAutoOrderTnC, 200);
        } else onAccept === null || onAccept === void 0 ? void 0 : onAccept();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        visible: visible,
        centered: true,
        onCancel: closeModal,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                size: "20px",
                align: "center",
                family: "bold",
                padding: "15px",
                children: "Syarat & Ketentuan"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                direction: "column",
                padding: "20px",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        direction: "column",
                        padding: "20px",
                        style: {
                            border: "1px solid rgb(237, 237, 237)",
                            borderRadius: "5px"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                family: "bold",
                                mb: "10px",
                                children: title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ul", {
                                style: {
                                    marginLeft: "-20px"
                                },
                                children: tnc.map(function(item) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                            padding: "5px",
                                            children: item
                                        })
                                    }, item);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_14__/* .Checkbox */ .XZ, {
                        onChange: function() {
                            return setTncAgree(!isTncAgree);
                        },
                        style: {
                            marginTop: "15px"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            children: checkboxDescription
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_14__/* .AutoBuySubmitButton */ .yJ, {
                disabled: !isTncAgree,
                onClick: onTncAgreed,
                type: "primary",
                radius: "4px",
                block: true,
                height: "40px",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    align: "inherit",
                    color: "inherit",
                    family: "bold",
                    size: "16px",
                    children: "Submit"
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (AutoOrderTncModal);


/***/ }),

/***/ 55039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jg": function() { return /* binding */ generateTradingVariable; },
/* harmony export */   "KK": function() { return /* binding */ checkIsAutoOrderTncAgreed; },
/* harmony export */   "xl": function() { return /* binding */ calculateLotAmendTransaction; }
/* harmony export */ });
/* unused harmony export getInvestmentFee */
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86123);
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83153);
/* harmony import */ var global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29097);
/* eslint-disable @typescript-eslint/no-unused-vars */ /* eslint-disable no-unused-vars */ /* eslint-disable no-eval */ 


var calculateLotAmendTransaction = function(previous_buy_price, previous_lot, price, lot) {
    // Prevent user increase lot with previous trade price
    // updating to use calculation procedure based on legacy
    // https://gitlab.com/stockbitgroup/stockbit/web/web/-/blob/staging/app/routes/securities/component/trade/ModalBuy.js#L351
    if (price === previous_buy_price && lot > previous_lot) {
        return previous_lot;
    }
    return lot;
};
var calculateInitialTradingBalance = function(stock_type, order_type, cash_on_hand, trading_balance, cash_onhand_amended, trading_balance_amended) {
    var isDayTrade = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false;
    if (stock_type.toLowerCase() === constants_trading__WEBPACK_IMPORTED_MODULE_1__/* .STOCK_TYPE.right */ .L2.right) {
        return order_type === constants_trading__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY ? cash_onhand_amended : cash_on_hand;
    }
    if (order_type === constants_trading__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY && isDayTrade) {
        return trading_balance;
    }
    return order_type === constants_trading__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY ? trading_balance_amended : trading_balance;
};
// eslint-disable-next-line import/prefer-default-export
var generateTradingVariable = function(param) {
    var configFormula = param.configFormula, cash_on_hand = param.cash_on_hand, trading_balance = param.trading_balance, price = param.price, lot = param.lot, trigger_price = param.trigger_price, config_type = param.config_type, order_type = param.order_type, previous_buy_price = param.previous_buy_price, previous_lot = param.previous_lot, stock_type = param.stock_type, trading_balance_amended = param.trading_balance_amended, cash_onhand_amended = param.cash_onhand_amended, _isDayTrade = param.isDayTrade, isDayTrade = _isDayTrade === void 0 ? false : _isDayTrade;
    if ((0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)()) {
        var _formula = configFormula.formula, fee_buy = _formula.fee_buy, fee_buy_day_trade = _formula.fee_buy_day_trade, buy_amount_invested = _formula.buy_amount_invested, buy_amount_invested_fee = _formula.buy_amount_invested_fee, buy_amount_fee = _formula.buy_amount_fee, buy_amount_broker_fee = _formula.buy_amount_broker_fee, buy_amount_exchange_fee = _formula.buy_amount_exchange_fee, preview_fee = configFormula.preview_fee, day_trade = configFormula.day_trade;
        var ref = isDayTrade ? day_trade === null || day_trade === void 0 ? void 0 : day_trade.preview_fee : preview_fee, broker_fee = ref.broker_fee, exchange = ref.exchange;
        var PRICE = Number(price);
        var LOT = Math.round(Number(lot));
        var TRIGGER_PRICE = Number(trigger_price);
        var CONFIG_TYPE = Number(config_type);
        if (order_type === constants_trading__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY) {
            LOT = calculateLotAmendTransaction(previous_buy_price, previous_lot, PRICE, LOT);
        }
        var FEE_BUY = isDayTrade ? Number(fee_buy_day_trade) : Number(fee_buy);
        var BROKER_FEE = Number(broker_fee);
        var EXCHANGE_FEE_TOTAL_BUY = Number(exchange.exchange_fee_total_buy);
        // if the source of eval script comes from controlled env (e.g. backend),
        // its relatively safe to use eval (https://stackoverflow.com/a/23175542)
        // so I add nosemgrep, to surprass nosemgrep
        var BUY_AMOUNT = eval(buy_amount_invested); // nosemgrep
        var BUY_AMOUNT_FEE = eval(buy_amount_invested_fee); // nosemgrep
        var BUY_FEE = eval(buy_amount_fee); // nosemgrep
        var STOCKBIT_FEE = eval(buy_amount_broker_fee); // nosemgrep
        var EXCHANGE_FEE = eval(buy_amount_exchange_fee); // nosemgrep
        var TRADING_BALANCE = calculateInitialTradingBalance(stock_type, order_type, cash_on_hand, trading_balance, cash_onhand_amended, trading_balance_amended, isDayTrade);
        var BUY_PRICE_WITH_FEE = (PRICE * FEE_BUY + PRICE) * global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_2__/* .lotSize */ .CQ;
        var LIMIT_LOT = Math.floor(TRADING_BALANCE / BUY_PRICE_WITH_FEE);
        return {
            TRADING_BALANCE: TRADING_BALANCE,
            BUY_AMOUNT_FEE: BUY_AMOUNT_FEE,
            BUY_AMOUNT: BUY_AMOUNT,
            PRICE: PRICE,
            BUY_FEE: BUY_FEE,
            STOCKBIT_FEE: STOCKBIT_FEE,
            EXCHANGE_FEE: EXCHANGE_FEE,
            LOT: LOT,
            LIMIT_LOT: LIMIT_LOT,
            TRIGGER_PRICE: TRIGGER_PRICE,
            CONFIG_TYPE: CONFIG_TYPE
        };
    }
    return null;
};
// eslint-disable-next-line import/prefer-default-export
var getInvestmentFee = function(param) {
    var configFormula = param.configFormula, price = param.price, lot = param.lot;
    if ((0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)()) {
        var _formula = configFormula.formula, fee_buy = _formula.fee_buy, buy_amount_invested_fee = _formula.buy_amount_invested_fee;
        var PRICE = Number(price);
        var LOT = Math.round(Number(lot));
        var FEE_BUY = Number(fee_buy);
        // if the source of eval script comes from controlled env (e.g. backend),
        // its relatively safe to use eval (https://stackoverflow.com/a/23175542)
        // so I add nosemgrep, to surprass nosemgrep
        var BUY_AMOUNT_FEE = eval(buy_amount_invested_fee); // nosemgrep
        return BUY_AMOUNT_FEE;
    }
    return 0;
};
var checkIsAutoOrderTncAgreed = function(userName, autoOrderType) {
    var logTnc = JSON.parse(localStorage.getItem("logTnc"));
    if (!logTnc) return false;
    var usernameFound = logTnc.find(function(item) {
        return item.username === userName && item.product === autoOrderType;
    });
    if (usernameFound) return true;
    return false;
};


/***/ }),

/***/ 53616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2078);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14671);
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29097);





var initialState = {
    configType: 2,
    expiry: global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_0__/* .Expiry.GoodForDay */ .ZM.GoodForDay,
    price: 0,
    shares: 0,
    stockCode: "",
    triggerPrice: 0,
    availableLot: 0,
    type: global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_0__/* .BuyOrderType.LimitOrder */ .dY.LimitOrder,
    typeDescription: "Limit Order",
    isSplitOrderActive: false,
    splitQuantity: null,
    splitRangeMin: null,
    splitRangeMax: null,
    splitMethod: global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_0__/* .SplitOrderMethodEnum.RANDOM */ .PH.RANDOM,
    sellLeverage: null,
    dayTradeActive: false,
    dayTradeMultiplier: 0
};
var realTradingStore = (0,zustand__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, initialState), {
        setConfigType: function(payload) {
            var index = _constant__WEBPACK_IMPORTED_MODULE_1__/* .triggerPriceOption.indexOf */ .mr.indexOf(payload);
            set({
                configType: index + 1
            });
        },
        setExpiry: function(expiry) {
            set({
                expiry: expiry
            });
        },
        setOrderType: function(type) {
            set({
                type: type
            });
        },
        setPrice: function(payload) {
            var value = Number(payload);
            set({
                price: value
            });
        },
        setAvailableLot: function(payload) {
            var value = Number(payload);
            set({
                availableLot: value
            });
        },
        setShares: function(payload) {
            var value = Number(payload);
            set({
                shares: value
            });
        },
        setStockCode: function(payload) {
            set({
                stockCode: payload
            });
        },
        setTriggerPrice: function(payload) {
            var value = Number(payload);
            set({
                triggerPrice: value
            });
        },
        resetOrderData: function() {
            set(initialState);
        },
        setTradingData: function(payload) {
            set((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, payload));
        },
        setSplitOrderActive: function(isSplitOrderActive) {
            set({
                isSplitOrderActive: isSplitOrderActive
            });
        },
        setSplitQuantity: function(splitQuantity) {
            set({
                splitQuantity: splitQuantity
            });
        },
        setSplitRange: function(splitRangeMin, splitRangeMax) {
            set({
                splitRangeMin: splitRangeMin,
                splitRangeMax: splitRangeMax
            });
        },
        setSellLeverage: function(sellLeverage) {
            set({
                sellLeverage: sellLeverage
            });
        },
        setDayTradeActive: function(active) {
            set({
                dayTradeActive: active
            });
        },
        setDayTadeMultiplier: function(multiplier) {
            set({
                dayTradeMultiplier: multiplier
            });
        },
        setSplitMethod: function setSplitMethod(splitMethod) {
            set({
                splitMethod: splitMethod
            });
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (realTradingStore);


/***/ }),

/***/ 61227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AP": function() { return /* binding */ CustomSelect; },
/* harmony export */   "Jm": function() { return /* binding */ TabPane; },
/* harmony export */   "UE": function() { return /* binding */ TabWrapper; },
/* harmony export */   "XZ": function() { return /* binding */ Checkbox; },
/* harmony export */   "d2": function() { return /* binding */ TriggerPriceSelect; },
/* harmony export */   "hv": function() { return /* binding */ DayTradeInfoBanner; },
/* harmony export */   "iR": function() { return /* binding */ Slider; },
/* harmony export */   "mQ": function() { return /* binding */ Tabs; },
/* harmony export */   "yJ": function() { return /* binding */ AutoBuySubmitButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19521);
/* harmony import */ var _deprecated_ui_common_Checkbox__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81190);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20539);
/* harmony import */ var _deprecated_ui_trading_Slider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22613);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22147);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76750);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-tabs-nav-list {\n    width: 100%;\n  }\n  .ant-tabs-nav-list {\n    .ant-tabs-tab {\n      width: 50%;\n      text-align: center;\n      font-family: var(--bold-font);\n\n      &.ant-tabs-tab-active {\n        color: ",
        ";\n        .ant-tabs-tab-btn {\n          color: ",
        ";\n        }\n      }\n\n      .ant-tabs-tab-btn {\n        width: 100%;\n        color: ",
        ";\n\n        :hover {\n          color: ",
        ";\n        }\n      }\n    }\n  }\n\n  .ant-tabs-ink-bar {\n    background-color: #0bba7a !important;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  border: solid 1px ",
        ";\n  height: 32px;\n  padding: 0 10px;\n  border-radius: 2px;\n\n  /* Add style when disabled*/\n  &:disabled {\n    color: #b5b5b5;\n    background: #f5f5f5;\n    cursor: not-allowed;\n    opacity: 0.7;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-width: 36px;\n  width: 36px;\n  margin-right: 0px;\n  text-indent: 0;\n  padding-left: 5px;\n  padding-right: 16px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  bottom: -55px;\n  width: 100%;\n\n  :disabled {\n    background: #616161;\n    border-color: #616161;\n    color: #bcbcbc;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n    color: ",
        " !important;\n  }\n\n  .ant-tabs-tab-active {\n    color: ",
        " !important;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-slider-step {\n    background-color: ",
        " !important;\n    height: 4px;\n    top: 4px;\n    z-index: 0;\n    border-radius: 2px;\n  }\n\n  .ant-slider-track {\n    border-radius: 2px;\n    height: 4px;\n    z-index: 1;\n  }\n\n  .ant-slider-handle {\n    z-index: 2;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-checkbox-checked .ant-checkbox-inner,\n  .ant-checkbox-indeterminate .ant-checkbox-inner {\n    background-color: #0bba7a;\n    border-color: #0bba7a;\n  }\n\n  .ant-checkbox-wrapper:hover .ant-checkbox-inner,\n  .ant-checkbox:hover .ant-checkbox-inner,\n  .ant-checkbox-input:focus + .ant-checkbox-inner {\n    border-color: #0bba7a !important;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  max-width: 318px;\n  display: flex;\n  align-items: center;\n  padding: 12px 16px;\n  background: #f2f1fe;\n  border-radius: 4px;\n  margin-top: 16px;\n  color: #333333;\n  font-size: 12px;\n  line-height: 16px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}






var BaseTabPane = antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"].TabPane */ .Z.TabPane;
var TabWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-174fa4c3-0"
})(_templateObject(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].mountainMeadow */ .Z.mountainMeadow, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].mountainMeadow */ .Z.mountainMeadow, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].highgray */ .Z.highgray, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].highgray */ .Z.highgray);
var CustomSelect = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].select.withConfig */ .ZP.select.withConfig({
    componentId: "sc-174fa4c3-1"
})(_templateObject1(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].gainsboro */ .Z.gainsboro);
var TriggerPriceSelect = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(CustomSelect).withConfig({
    componentId: "sc-174fa4c3-2"
})(_templateObject2());
var AutoBuySubmitButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-174fa4c3-3"
})(_templateObject3());
var TabPane = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(BaseTabPane).withConfig({
    componentId: "sc-174fa4c3-4"
})(_templateObject4());
var Tabs = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-174fa4c3-5"
})(_templateObject5(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].primary */ .Z.primary);
var Slider = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_trading_Slider__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-174fa4c3-6"
})(_templateObject6(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].gainsboro */ .Z.gainsboro);
var Checkbox = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Checkbox__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-174fa4c3-7"
})(_templateObject7());
var DayTradeInfoBanner = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-174fa4c3-8"
})(_templateObject8());



/***/ }),

/***/ 64700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useToggle = function() {
    var initialToggleState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialToggleState), isVisible = ref[0], setVisibility = ref[1];
    var toggle = function() {
        setVisibility(!isVisible);
    };
    return [
        isVisible,
        toggle
    ];
};
/* harmony default export */ __webpack_exports__["Z"] = (useToggle);


/***/ }),

/***/ 14732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "aX": function() { return /* binding */ getShareTradeSetting; },
  "JG": function() { return /* binding */ getShareTradeTarget; },
  "cm": function() { return /* binding */ postShareTradeShare; },
  "E8": function() { return /* binding */ putShareTradeSetting; },
  "wm": function() { return /* binding */ putShareTradeTarget; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/lib/api/instances/exodus.ts
var exodus = __webpack_require__(78372);
;// CONCATENATED MODULE: ./src/lib/api/shareTrade/endpoints.ts
var shareTradeEndpoints = {
    setting: "/sharetrade/setting",
    settingAutoShare: "/sharetrade/setting/autoshare",
    target: "/sharetrade/target",
    share: "/sharetrade/share"
};
/* harmony default export */ var endpoints = (shareTradeEndpoints);

;// CONCATENATED MODULE: ./src/lib/api/shareTrade/index.ts




var defaultInstance = exodus/* default.defaultInstance */.Z.defaultInstance;
var setting = endpoints.setting, settingAutoShare = endpoints.settingAutoShare, target = endpoints.target, share = endpoints.share;
var getShareTradeSetting = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", defaultInstance.get(setting));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getShareTradeSetting() {
        return _ref.apply(this, arguments);
    };
}();
var putShareTradeSetting = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(requestBody) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", defaultInstance.put(settingAutoShare, requestBody));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function putShareTradeSetting(requestBody) {
        return _ref.apply(this, arguments);
    };
}();
var getShareTradeTarget = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(params) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", defaultInstance.get(target, {
                        params: params
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getShareTradeTarget(params) {
        return _ref.apply(this, arguments);
    };
}();
var putShareTradeTarget = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(requestBody) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", defaultInstance.put(target, requestBody));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function putShareTradeTarget(requestBody) {
        return _ref.apply(this, arguments);
    };
}();
var postShareTradeShare = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(requestBody) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", defaultInstance.post(share, requestBody));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postShareTradeShare(requestBody) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 75774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var global_AlertMessage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6430);
/* harmony import */ var lib_api_shareTrade__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14732);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14671);







var initialState = {
    isLoading: false,
    error: undefined,
    transactionData: undefined
};
var useShareTradeShare = (0,zustand__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState), {
        setTransactionData: function(transactionData) {
            set({
                transactionData: transactionData
            });
        },
        loadShareTradeShare: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(requestBody) {
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoading: true
                            });
                            _ctx.next = 4;
                            return (0,lib_api_shareTrade__WEBPACK_IMPORTED_MODULE_2__/* .postShareTradeShare */ .cm)(requestBody);
                        case 4:
                            set({
                                isLoading: false,
                                error: undefined
                            });
                            return _ctx.abrupt("return", Promise.resolve());
                        case 8:
                            _ctx.prev = 8;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false,
                                error: _ctx.t0
                            });
                            (0,global_AlertMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                                alertType: "plain-default",
                                messageType: "error",
                                content: "Unable to share trade at this moment"
                            });
                            return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                        case 13:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        8
                    ]
                ]);
            }));
            return function(requestBody) {
                return _ref.apply(this, arguments);
            };
        }()
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (useShareTradeShare);


/***/ }),

/***/ 10529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ ShareOrderStatus; },
/* harmony export */   "y": function() { return /* binding */ ShareOrderType; }
/* harmony export */ });
var ShareOrderType;
(function(ShareOrderType) {
    ShareOrderType["Unspecified"] = "ORDER_TYPE_UNSPECIFIED";
    ShareOrderType["Buy"] = "ORDER_TYPE_BUY";
    ShareOrderType["Sell"] = "ORDER_TYPE_SELL";
})(ShareOrderType || (ShareOrderType = {}));
var ShareOrderStatus;
(function(ShareOrderStatus) {
    ShareOrderStatus["Unspecified"] = "ORDER_STATUS_UNSPECIFIED";
    ShareOrderStatus["Open"] = "ORDER_STATUS_OPEN";
    ShareOrderStatus["Amend"] = "ORDER_STATUS_AMEND";
    ShareOrderStatus["Cancel"] = "ORDER_STATUS_CANCEL";
    ShareOrderStatus["Match"] = "ORDER_STATUS_MATCH";
    ShareOrderStatus["PartialMatch"] = "ORDER_STATUS_PARTIAL_MATCH";
})(ShareOrderStatus || (ShareOrderStatus = {}));


/***/ }),

/***/ 75738:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var isAxiosError = function(error) {
    return typeof error === "object" && (error === null || error === void 0 ? void 0 : error.isAxiosError);
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    isAxiosError: isAxiosError
});


/***/ }),

/***/ 67600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JH": function() { return /* binding */ generateOrderTypeLabel; },
/* harmony export */   "d8": function() { return /* binding */ generateOrderExpiryLabel; }
/* harmony export */ });
/* unused harmony export generateOrderLeverageLabel */
/* harmony import */ var global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2078);

function generateOrderLeverageLabel(method) {
    var leverageLabel = "";
    switch(method){
        case PaymentMethod.DayTrade:
            leverageLabel = "Day Trade";
            break;
        case PaymentMethod.TradingLimit:
            leverageLabel = "Trading Limit";
            break;
        default:
            leverageLabel = "Trading Balance";
    }
    return leverageLabel;
}
function generateOrderTypeLabel(orderType) {
    var orderTypeLabel = "";
    switch(orderType){
        case global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_0__/* .BuyOrderType.AutoBuy */ .dY.AutoBuy:
            orderTypeLabel = "Auto Buy";
            break;
        case global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_0__/* .BuyOrderType.MarketOrder */ .dY.MarketOrder:
            orderTypeLabel = "Market Order";
            break;
        case global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_0__/* .BuyOrderType.LimitOrder */ .dY.LimitOrder:
        default:
            orderTypeLabel = "Limit Order";
            break;
    }
    return orderTypeLabel;
}
function generateOrderExpiryLabel(expiry) {
    var expiryLabel = "";
    switch(expiry){
        case 0:
            expiryLabel = "Good for day";
            break;
        case 1:
            expiryLabel = "Good till canceled";
            break;
        default:
            expiryLabel = "";
    }
    return expiryLabel;
}


/***/ })

}]);